import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63f9904c"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports